module.exports = __webpack_public_path__ + "img/PjiliPlus.da69fc39.svg";